import React, { FC } from 'react'
// import { EnvironmentSelect } from 'components/input/EnvironmentSelect'
import { TabListItemProps } from 'components/tab/TabList'
import { MenuContainer } from '../Menu'
import { Button } from '@epidemicsound/design-system/v2'
import auth from 'api/auth'
import styled from 'styled-components'

const StyledButton = styled(Button)`
    height: fit-content;
`

export const Menu: FC = () => {
    const tabs: TabListItemProps[] = [
        {
            label: 'Partners',
            url: '/partners',
            match: /^\/internal\/(partners)/,
        },
        {
            label: 'Tiers',
            url: '/tiers',
            match: /^\/internal\/(tiers)/,
        },
        {
            label: 'Products',
            url: '/products',
            match: /^\/internal\/(products)/,
        },
        {
            label: 'Collection Library',
            url: '/collections/library',
            match: /^\/internal\/(collections)\/(library)/,
        },
    ]

    const doLogout = () => {
        auth.logout('Internal')
    }

    return (
        <>
            <MenuContainer tabs={tabs} app={'Internal'} />
            <StyledButton
                variant="secondary"
                onClick={doLogout}
                data-cy-sign-out
            >
                Sign out
            </StyledButton>
        </>
    )
}
